export default __webpack_public_path__ + "static/media/Yael_Geffen_AHV_In_Moms_We_Trust.9893eb0c.jpg";